import moment from 'moment';
import ttnLogo from './Assets/images/TTN_logo.png';
import cloudLogo from './Assets/images/cloudkeeper_logo.png';
import idanimLogo from './Assets/images/idanim_logo.png';

export const formatDateToInteger = (date) => moment(date).format('YYYYMMDD');

export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const getLogo = (notifyEmail = '') => {
  const domain = notifyEmail.toLowerCase();
  if(domain.indexOf('cloudkeeper') !== -1) {
    return cloudLogo;
  }else if(domain.indexOf('idanim') !== -1) {
    return idanimLogo;
  }else{
    return ttnLogo;
  }
};

export const getCompanyName = (notifyEmail = '') => {
  const domain = notifyEmail.toLowerCase();
  if(domain.indexOf('idanim') !== -1) {
    return 'Idanim';
  }else{
    return 'TO THE NEW';
  }
};
